// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";
import axios from "axios";
import _ from "lodash";
import { Loader, Image } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useFeatures } from "flagged";

// Import from Config
// -------------------------------------
import { baseUrl } from "@api/apiV6";
import { Div } from "@components/Generics.react";
import AuthLayout from "@layouts/AuthLayout.react";
import Scorm from "@utilities/scormHelpers";

// Import Components
// -------------------------------------

export default function SCORMLogin(props) {
    const { team, loginAction, branding } = props;
    const { t } = useTranslation("common");
    const features = useFeatures();

    const [error, setError] = useState(null);

    const wPageHt = window.innerHeight - 100;
    const isPortrait = window.innerHeight > window.innerWidth;

    useEffect(() => {
        Scorm.init();
        setTimeout(() => {
            const scormData = Scorm.getLMSData();
            tryLogin(
                scormData.student_id,
                _.reverse(scormData.student_name.split(", "))
            );
        }, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tryLogin = async (username, fullName) => {
        try {
            let formData = new FormData();
            formData.append("first_name", fullName[0]);
            formData.append("last_name", fullName[1]);
            formData.append("username", username);
            formData.append("team", features.scorm.team);
            formData.append("password", "blank");
            const response = await axios({
                method: "post",
                url: `${baseUrl}api/v3/auth/scorm_sign_in`,
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });
            loginAction(response);
        } catch (error) {
            console.log(error);
            setError(error.response?.data?.message);
        }
    };

    const screenView = () => {
        if (error)
            return (
                <Div center-align large>
                    <Div gutter>{error}</Div>
                </Div>
            );
        else
            return (
                <Div flex ht="256px">
                    <Loader active>Logging in...</Loader>
                </Div>
            );
    };

    // ========================= Render Function =================================
    return (
        <AuthLayout
            title={`Login to ${t("appName")}`}
            team={team}
            teamLogin={true}
        >
            <Div
                fluid
                superpad
                ht={isPortrait ? wPageHt : "100%"}
                flex
                centered
                maxWd="480px"
                key="login-box"
            >
                <Div wd="60%" gutter>
                    <Image src={branding?.image} />
                </Div>
                <Div fluid white fullHt superpad rounded>
                    {screenView()}
                </Div>
            </Div>
        </AuthLayout>
    );
}
